import { Icon } from '@iconify/react';
import { useMsal } from '@azure/msal-react';

// material
import { Stack, Button, Typography } from '@material-ui/core';

// ----------------------------------------------------------------------

export default function AuthSocial() {
  const { instance } = useMsal();

  const handleSignIn = () => {
    instance.loginRedirect();
  };
  return (
    <>
      <Stack direction="column" spacing={2}>
        <Typography align="center" variant="h4">
          Login with Microsoft
        </Typography>
        <Button fullWidth size="large" color="inherit" variant="outlined" onClick={handleSignIn}>
          <Icon icon="logos:microsoft-icon" height={24} />
        </Button>
      </Stack>
    </>
  );
}
